import { useEffect, useRef, useState } from "react";

export default function ScrollView({ catalog, lang, landscape, start = 0, onZoom, onPage }) {
  const box = useRef(null);
  const [i, setI] = useState(start);
  const pages = catalog.hd || catalog.pages;
  const n = pages.length;

  useEffect(() => {
    const el = box.current?.querySelector(`[data-k="${start}"]`);
    if (el) el.scrollIntoView({ block: "start", inline: "center" });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => onPage(i), [i, onPage]);

  const onScroll = () => {
    const b = box.current;
    const r = b.getBoundingClientRect();
    const mid = landscape ? r.left + r.width / 2 : r.top + r.height / 3;
    let best = 0, dist = Infinity;
    b.querySelectorAll("[data-k]").forEach((el) => {
      const e = el.getBoundingClientRect();
      const d = landscape ? Math.abs(e.left + e.width / 2 - mid) : (e.top <= mid && e.bottom >= mid ? 0 : Math.min(Math.abs(e.top - mid), Math.abs(e.bottom - mid)));
      if (d < dist) { dist = d; best = Number(el.dataset.k); }
    });
    setI(best);
  };

  return (
    <div className="relative flex-1 min-h-0">
      <div
        ref={box}
        onScroll={onScroll}
        data-lenis-prevent
        data-testid="viewer-scroll"
        className={landscape
          ? "h-full flex overflow-x-auto snap-x snap-mandatory overscroll-contain [scrollbar-width:none]"
          : "h-full overflow-y-auto overscroll-contain px-3 pb-24 space-y-3"}
      >
        {pages.map((p, k) => (
          <button
            key={p}
            data-k={k}
            onClick={() => onZoom(k)}
            className={landscape ? "snap-center shrink-0 w-full h-full flex items-center justify-center px-2" : "block w-full aspect-[1.413/1] rounded-lg overflow-hidden bg-white/5 shadow-[0_20px_40px_-20px_rgba(0,0,0,0.8)]"}
            data-testid={`scroll-page-${k + 1}`}
          >
            <img src={p} alt={`${k + 1}`} loading={Math.abs(k - start) < 3 ? "eager" : "lazy"} className={landscape ? "max-h-full max-w-full object-contain rounded-md aspect-[1.413/1]" : "w-full h-full object-cover"} />
          </button>
        ))}
      </div>
      <div className="pointer-events-none absolute bottom-4 inset-x-0 flex justify-center">
        <span className="rounded-full bg-black/60 backdrop-blur-md ring-1 ring-white/10 px-3.5 py-1.5 text-[12px] text-white/85" data-testid="viewer-counter">
          {i + 1} / {n} · {lang === "it" ? "tocca per ingrandire" : "tap to zoom"}
        </span>
      </div>
    </div>
  );
}
